<div class="d-flex flex-column">
	<div class="h4">POS</div>

	<div class="p-grid w-100">
		<div class="p-col">Stations: {{ venueSelected.VenuePos.stations }}</div>
		<div class="p-col">
			<div>Focus Version {{ venueSelected.VenuePos.version }}</div>
		</div>
	</div>
	<div class="h4">Payments</div>
	<div class="p-grid">
		<div class="p-col">Provider {{ venueSelected.VenuePos.creditPlatform }}</div>
		<div class="p-col">Credit Station: {{ venueSelected.VenuePos.creditStation }}</div>
	</div>
	<div class="h4">Station Assignments</div>
	<div class="p-grid">
		<div class="p-col">Event: {{ venueSelected.VenuePos.eventStation }}</div>
		<div class="p-col">Email: {{ venueSelected.VenuePos.emailStation }}</div>
		<div class="p-col">Mobile: {{ venueSelected.VenuePos.mobileStation }}</div>
	</div>
	<div class="h4">Modules</div>
	<div class="p-grid">
		<div class="col-4">
			<p-checkbox name="venueBOH" binary="true" [(ngModel)]="venueSelected.VenuePos.bof" label="Back Office" [disabled]="true"></p-checkbox>
		</div>
		<div class="col-4">
			<p-checkbox name="venueCUS" binary="true" [(ngModel)]="venueSelected.VenuePos.cus" label="Customer" [disabled]="true"></p-checkbox>
		</div>
		<div class="col-4">
			<p-checkbox name="venueSCH" binary="true" [(ngModel)]="venueSelected.VenuePos.sch" label="Scheduling" [disabled]="true"></p-checkbox>
		</div>
	</div>
	<div class="p-grid">
		<div class="col-4">
			<p-checkbox name="venueGFT" binary="true" [(ngModel)]="venueSelected.VenuePos.gft" label="3rd Pty Gift" [disabled]="true"></p-checkbox>
		</div>
		<div class="col-4">
			<p-checkbox name="venueINV" binary="true" [(ngModel)]="venueSelected.VenuePos.inv" label="Inventory" [disabled]="true"></p-checkbox>
		</div>
		<div class="col-4">
			<p-checkbox name="venueXML" binary="true" [(ngModel)]="venueSelected.VenuePos.xml" label="XML Datafeed" [disabled]="true"></p-checkbox>
		</div>
	</div>
	<div class="p-grid">
		<div class="col-4">
			<p-checkbox name="venueIPL" binary="true" [(ngModel)]="venueSelected.VenuePos.ipl" label="Camera Interface" [disabled]="true"></p-checkbox>
		</div>
		<div class="col-4">
			<p-checkbox name="venueALR" binary="true" [(ngModel)]="venueSelected.VenuePos.alr" label="Legacy SMS" [disabled]="true"></p-checkbox>
		</div>
		<div class="col-4">
			<p-checkbox name="venueSQL" binary="true" [(ngModel)]="venueSelected.VenuePos.sql" label="SQL Server" [disabled]="true"></p-checkbox>
		</div>
	</div>
	<div>Third Party Interfaces</div>
	<div class="p-grid">
		<div class="col-4">
			<p-checkbox name="venueHOT" binary="true" [(ngModel)]="venueSelected.VenuePos.hot" label="HotSchedules" [disabled]="true"></p-checkbox>
		</div>
		<div class="col-4">
			<p-checkbox
				name="venueOTB"
				binary="true"
				[(ngModel)]="venueSelected.VenuePos.otb"
				pTooltip="Ha remember the ONE day that worked?"
				label="OpenTable"
				[disabled]="true"
			></p-checkbox>
		</div>
		<div class="col-4">
			<p-checkbox name="venueONL" binary="true" [(ngModel)]="venueSelected.VenuePos.onl" label="Legacy OO" [disabled]="true"></p-checkbox>
		</div>
	</div>
	<div class="p-grid">
		<div class="col-4">
			<p-checkbox name="venuePMS" binary="true" [(ngModel)]="venueSelected.VenuePos.pms" label="Hotel PMS" [disabled]="true"></p-checkbox>
		</div>
	</div>
</div>
